export const googleRatingList1 = [
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a/ACg8ocKWdIFtxukbeD4XonN4hXLsM-nhmpvSR2ort8AHHk1axIc=w36-h36-p-rp-mo-br100',
    Name: 'Ashwani',
    Designation: 'Google Review',
    Description: `Provides good levels of support and resistance along with Magic figure - helps in making your trade`,
    Time: '3 Months ago',
    Link: 'https://g.co/kgs/GEDnShs',
  },
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a-/ALV-UjV9eXB4rBsQdv9_qOzqh3-JxuZYY0mDMqKzCViin8wLRNg=w36-h36-p-rp-mo-br100',
    Name: 'Santosh Kumar',
    Designation: 'Google Review',
    Description: `Really your direction is best. Which times made money and which times saved money. Both are part of income. Thank you.`,
    Time: '3 Months ago',
    Link: 'https://g.co/kgs/mxitVte',
  },
];

export const googleRatingList2 = [
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a-/ALV-UjWAPp5hg48xcy6AtiHfjuqVDYqihSSiXJH5QRQEYVBSGzk=w36-h36-p-rp-mo-br100',
    Name: 'Nikhil Moonat',
    Designation: 'Google Review',
    Description: `This channel is like your lic policy
    Trade ke sath bhi trade k baad bhi
    I m fond of your dedication Amit ji...`,
    Time: '3 Months ago',
    Link: 'https://g.co/kgs/YuNigTz',
  },
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a-/ALV-UjVMABkRmlGhDe4GVI2QP0p2nP9TUc7kfEU7ogTugJ8boOc=w36-h36-p-rp-mo-br100',
    Name: 'ANIKET TAKALKAR',
    Designation: 'Google Review',
    Description: `I have been watching Sir's videos since I started trading... 99.99% of his predictions were correct...  After having much confidence I took paid channel and services provided are too good... `,
    Time: '3 Months ago',
    Link: 'https://g.co/kgs/BziV2tp',
  },
];
export const googleRatingList3 = [
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a-/ALV-UjUzze-Xdj4clMOe7OiaKj_il6mfdCiIJB6UcrtOMYYIbxGE=w90-h90-p-rp-mo-br100',
    Name: 'P P',
    Designation: 'Google Review',
    Description: `I have never seen a brilliant man like Amit Jain sir till today. I have been watching his free YouTube channel videos daily for the past two years...`,
    Time: '3 Months ago',
    Link: 'https://g.co/kgs/fkTXjNG',
  },
  {
    ProfileImage:
      'https://lh3.googleusercontent.com/a-/ALV-UjUVboONCsIofa21a0C5AjFC2HRE03X8c_oghePQXPAhiQ=w36-h36-p-rp-mo-ba2-br100',
    Name: 'Aakash Patwa',
    Designation: 'Google Review',
    Description: `Intelysis Naam hi nahin ek brand hai..
     Aaj Tak sirf movie mein dekha hai ki neki karna chahie Aaj vo intelisys ke sath judkar Hakikat mein dekhi hai..
     शब्द कम है intelysis की तारीफ के लिए...
     Thank you so much Amit sir...`,
    Time: 'A year ago',
    Link: 'https://g.co/kgs/LfzRrmk',
  },
];
